import { defineComponent as _defineComponent } from 'vue'
type calculate = 'increase' | 'decrease';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CalculationButton',
  props: {
    type: null,
    disabled: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({(e: calculate): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        type: calculate,
        disabled: boolean,
    }

    

    

    const calculationButtonClick = () => {
        if (props.disabled) {
            return;
        }
        emit(props.type);
    };

return { __sfc: true,props, emit, calculationButtonClick }
}

})